var modules_578c5184 = {"container":"Heading_module_container__83e4fb27","size-1":"Heading_module_size1__83e4fb27","size-2":"Heading_module_size2__83e4fb27","size-3":"Heading_module_size3__83e4fb27","size-4":"Heading_module_size4__83e4fb27","size-5":"Heading_module_size5__83e4fb27","size-6":"Heading_module_size6__83e4fb27"};
import "../../../assets/esm/components/Typography/src/Heading~CncmyOp4.css";

export { modules_578c5184 as default };
//# sourceMappingURL=Heading.module.less.js.map
